import $ from 'jquery';

$(document).ready(function() {
    // Check if the current page is page 641
    if (mainSiteData.page_id === '641') {
        
        // slider ajax
        $(document).on('click', '.gallery-link', function(e) {
            e.preventDefault();

            // Set the active state for the clicked gallery link
            $('.gallery-link.active').removeClass('active');
            $(this).addClass('active');

            var galleryId = $(this).data('gallery-id');
            
            $.ajax({
                url: mainSiteData.ajax_url,
                type: 'POST',
                data: {
                    action: 'load_gallery',
                    gallery_id: galleryId,
                    _ajax_nonce: mainSiteData.auth_nonce
                },
                success: function(response) {
                    // Update the gallery content
                    $('#gallery-content').html(response);

                    // Initialize Slick on the content slider
                    $('.content-slider').slick({
                        dots: true,
                        arrows: false,
                        infinite: false,
                        speed: 500,
                        variableWidth: true,
                        focusOnSelect: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    });

                    // Trigger the initial update for the featured image
                    const initialLargeImage = $('.content-slider .slick-current img').data('large');
                    $('.featured-image').css('background-image', 'url(' + initialLargeImage + ')');
                },
                error: function(xhr, status, error) {
                    console.log('Error: ' + error);
                }
            });
        });

        // Update the featured image on slide change
        $(document).on('afterChange', '.content-slider', function(event, slick, currentSlide) {
            // Get the active slide in Slick
            const activeSlide = slick.$slides.eq(currentSlide);
            const largeImageUrl = activeSlide.find('img').data('large'); // Get the large image URL from the data attribute

            // Update the featured image
            if (largeImageUrl) {
                $('.featured-image').css('background-image', 'url(' + largeImageUrl + ')');
            }
        });
    }
});
